import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';
import Rectangle from '../../../../source/js/shared/models/Geometry/Rectangle';
import AbstractShape from '../Shapes/AbstractShape';
import { ValidatorInterface } from '../Validators/ValidatorInterface';

export default class EggConfiguration implements ShapeConfigurationInterface {
	public hasNewValidators = true;

	get_dimension_keys(): string[] {
		return [
			'width',
			'height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		return {
			width: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_shortest_side(),
		};
	}

	get_minimum_dimensions( minimum: number ): Record<string, Length>|null {
		return {
			width: Length.from_cm( minimum ),
			height: Length.from_cm( minimum ),
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_new_validators( instance: AbstractShape, minimum: number, maximums: Record<string, Length> ): ValidatorInterface[] {
		return [
			new MaximumDecimalPoints( {
				field: 'egg-height',
				dimension: 'height',
				instance,
				decimalPoints: 1,
			} ),
			new MinimumValue( {
				field: 'egg-height',
				dimension: 'height',
				instance,
				minimum,
			} ),
			new MaximumValue( {
				field: 'egg-height',
				dimension: 'height',
				instance,
				maximums,
			} ),
			new MaximumDecimalPoints( {
				field: 'egg-width',
				dimension: 'width',
				instance,
				decimalPoints: 1,
			} ),
			new MinimumValue( {
				field: 'egg-width',
				dimension: 'width',
				instance,
				minimum,
			} ),
			new MaximumValue( {
				field: 'egg-width',
				dimension: 'width',
				instance,
				maximums,
			} ),
		];
	}

	get_cutout_validators(): ValidatorInterface[] {
		return [];
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
